export default class CheckboxRadio {
  constructor(node) {
    this.element = node;
    this.radioWrapper = this.element.querySelector(".js-radio-wrapper");
    this.checkbox = this.element.querySelector(".js-checkbox");
    this.radios = this.element.querySelectorAll(".js-radio");

    this.checkbox.addEventListener("change", (e) => {
      this.toggleDisable(e.currentTarget.checked);
    });
  }
  toggleDisable(checked) {
    this.radioWrapper.classList.toggle("disabled", !checked);
    this.radios.forEach((radio) => {
      radio.disabled = !checked;
    });
  }
}
